import { ajax } from '../../../common/http/authAjax';
import { map } from 'rxjs/operators';
import { Saisine } from '../../domain/saisine';
import { Case } from '../../../casescontext/domain/case';

const headers = () => ({
  'x-access-token': localStorage.getItem('admin-token'),
  'Content-Type': 'application/json',
});

function mapSaisineDetail(data) {
  const { data: saisine, computedTotal, warnings } = data.response;
  return Saisine({ ...saisine, computedTotal, warnings });
}

function mapSaisineList(data) {
  return {
    saisines: data.response.data.map((saisine) => Saisine(saisine)),
    total: data.response.total,
  };
}

function mapEligibleClaims(data) {
  return data.response.data.map((claim) => Case({ passengers: [], ...claim }));
}

export function SaisineGateway() {
  return {
    retrieveSaisines(search) {
      return ajax.get(`${process.env.REACT_APP_API_URL}/api/saisines${search}`, headers()).pipe(
        map((data) => mapSaisineList(data)),
      );
    },
    retrieveSaisineById(id) {
      return ajax.get(`${process.env.REACT_APP_API_URL}/api/saisine?id=${id}`, headers()).pipe(
        map((data) => mapSaisineDetail(data)),
      );
    },
    createSaisine(claimIds) {
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/saisine/create`, { claimIds }, headers()).pipe(
        map((data) => ({
          saisine: mapSaisineDetail(data),
          rejected: data.response.rejected || [],
        })),
      );
    },
    addClaim(saisineId, claimId) {
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/saisine/claim/add`, { saisineId, claimId }, headers()).pipe(
        map((data) => mapSaisineDetail(data)),
      );
    },
    removeClaim(saisineId, claimId) {
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/saisine/claim/remove`, { saisineId, claimId }, headers()).pipe(
        map((data) => mapSaisineDetail(data)),
      );
    },
    deleteSaisine(saisineId) {
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/saisine/delete`, { saisineId }, headers());
    },
    validateSaisine(saisineId) {
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/saisine/validate`, { saisineId }, headers()).pipe(
        map((data) => mapSaisineDetail(data)),
      );
    },
    searchEligibleClaims(saisineId, text) {
      const params = new URLSearchParams();
      if (saisineId) params.append('saisineId', saisineId);
      if (text) params.append('text', text);
      return ajax.get(`${process.env.REACT_APP_API_URL}/api/saisine/eligible-claims?${params.toString()}`, headers()).pipe(
        map((data) => mapEligibleClaims(data)),
      );
    },
    generateDocuments(claimIds) {
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/generate/court/list`, { recordsId: claimIds }, headers());
    },
    autofillPreview() {
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/saisine/autofill/preview`, {}, headers()).pipe(
        map((data) => data.response),
      );
    },
    autofillApply(proposal) {
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/saisine/autofill/apply`, proposal, headers()).pipe(
        map((data) => data.response),
      );
    },
  };
}
